import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Contact from "@/components/Contact";
import PageMeta from "@/components/PageMeta";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqItems = [
  {
    question: "Hvor lang tid tar det å sy en bunad?",
    answer: "Det tar vanligvis 6-12 måneder å sy en komplett bunad, avhengig av kompleksiteten og vår arbeidsmengde. Vi anbefaler å bestille i god tid før du trenger bunaden."
  },
  {
    question: "Kan jeg bestille bunad til barn?",
    answer: "Ja, vi syr bunader til både barn og voksne. Barnebunader kan tilpasses for å kunne sys ut etter hvert som barnet vokser."
  },
  {
    question: "Hvordan tar jeg vare på bunaden min?",
    answer: "Bunaden bør oppbevares hengende i et bunadsbeskyttelse eller poseskap. Unngå å oppbevare den i plast, da dette kan føre til fuktskader. Vi anbefaler profesjonell rens når nødvendig."
  },
  {
    question: "Tilbyr dere tilpasninger av eksisterende bunader?",
    answer: "Ja, vi kan gjøre tilpasninger på eksisterende bunader, inkludert endring av størrelse, reparasjoner og oppfriskning av broderier."
  },
  {
    question: "Kan jeg komme til prøvetime?",
    answer: "Absolutt! Vi anbefaler prøvetimer for å sikre perfekt passform. Ta kontakt for å avtale en time som passer for deg."
  },
  {
    question: "Hvor kommer materialene fra?",
    answer: "Vi bruker ullstoff fra Lillehammer, garn fra Rauma, og broderier utføres av dyktige håndverkere over hele Norge. Alt settes sammen i vår butikk i Levanger."
  }
];

const Sporsmal = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <PageMeta
        title="Ofte stilte spørsmål om bunader"
        description="Finn svar på vanlige spørsmål om bunader, bestilling, levering, tilpasninger og vedlikehold. Bunadstuggu hjelper deg med alt du lurer på."
        path="/sporsmal"
      />
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="relative pt-24 pb-16 lg:pt-32 lg:pb-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-12">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors font-sans text-sm mb-8"
            >
              <ArrowLeft className="w-4 h-4" />
              Tilbake til forsiden
            </Link>

            <div className="text-center max-w-3xl mx-auto mb-12">
              <p className="text-primary font-sans text-xs tracking-[0.3em] uppercase mb-4">
                FAQ
              </p>
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground mb-6">
                Ofte stilte spørsmål
              </h1>
              <p className="text-muted-foreground font-sans leading-relaxed">
                Her finner du svar på de vanligste spørsmålene om bunader, bestilling og tilbehør. 
                Finner du ikke svaret du leter etter? Ta gjerne kontakt med oss.
              </p>
            </div>

            {/* FAQ Accordion */}
            <Accordion type="single" collapsible className="w-full space-y-4">
              {faqItems.map((item, index) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`}
                  className="bg-cream rounded-lg px-6 border-none"
                >
                  <AccordionTrigger className="text-left font-serif text-lg hover:no-underline py-5">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground font-sans leading-relaxed pb-5">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </section>

        {/* Contact Section */}
        <Contact />
      </main>

      <Footer />
    </div>
  );
};

export default Sporsmal;
